// Admin emails that bypass subscription requirements
const ADMIN_EMAILS = [
  'medstudypro1@gmail.com',
  'medstudypro@gmail.com'
];

/**
 * Check if an email belongs to an admin user
 * @param {string} email - User's email address
 * @returns {boolean} - True if user is an admin
 */
export const isAdmin = (email) => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase().trim());
};

/**
 * Get list of admin emails
 * @returns {string[]} - Array of admin email addresses
 */
export const getAdminEmails = () => ADMIN_EMAILS;

export default isAdmin;
